import "./Home.css";
import { useEffect, useState } from "react";
import equipe_joao from "../../../src/assets/img/joao.png";
import equipe_le from "../../../src/assets/img/leticia.png";
import { Col, Form, Row } from "react-bootstrap";
import desenvolvimento from "../../../src/assets/img/desenvolvimento.png";
import aplicativo from "../../../src/assets/img/aplicativos.png";
import suporte from "../../../src/assets/img/suporte.png";
import sites from "../../../src/assets/img/sites.png";
import marketing from "../../../src/assets/img/marketing.png";
import planejamento from "../../../src/assets/img/planejamento.png";
import ContactInfo from "../../components/ContactInfo/ContactInfo";
import Slider from "react-slick";
import { useMediaQuery } from 'react-responsive';
import { openWhatsApp } from "../../utils/whatsapp";
import emailjs from 'emailjs-com';
import { toast  }  from  'react-toastify' ;

function Home() {

  const [service, setService] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    className: "center",
    centerMode: true,
  };

  const images = {
    desenvolvimento,
    aplicativo,
    suporte,
    sites,
    marketing,
    planejamento,
  };

  useEffect(() => {
    fetch("/mock/service.json")
      .then((res) => res.json())
      .then((result) => {
        setService(result.data);
      });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setIsLoading(true);

    emailjs.sendForm(
      'service_l61k9ch',     
      'template_ixz0agr',       
      e.target,
      'ez2r0S9_kbS37TQqj'     
    )
    .then((result) => {
      toast.success("Mensagem enviada com sucesso!");
      e.target.reset();
    })
    .catch(() => {
      toast.error("Erro ao enviar mensagem.");
    })
    .finally(() => {
      setIsLoading(false);
    });

  };

  const renderForm = () => {
    return (
      <>
        {!isLoading ? (
          <>
            <div className="d-flex flex-column">
              <span className="message-title">Orçamento</span>
              <span className="message-text">
                Solicite agora o seu orçamento personalizado e descubra como
                podemos transformar sua ideia em realidade.
              </span>
            </div>
            <Form onSubmit={sendEmail} className="mt-5">
              <Row>
                <Col md={6} sm={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control" 
                    placeholder="Nome"
                    name="name"
                    required
                  />
                </Col>
                <Col md={6} sm={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="E-mail"
                    name="email"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Título"
                    name="title"
                    required
                  />
                </Col>
                <Col md={12} className="mb-3">
                  <div className="form-floating">
                    <textarea
                      className="form-control"
                      placeholder="Mensagem"
                      style={{ height: "100px" }}
                      name="message"
                      required
                    ></textarea>
                    <label for="floatingTextarea2">Mensagem</label>
                  </div>
                </Col>
                <Col md={12} className="button-form-submit">
                  <button className="button-submit">Enviar</button>
                </Col>
              </Row>
            </Form>
          </>
        ) : (          
          <div>
            <i className="bi bi-arrow-clockwise icon-arrow-clockwise spin"></i>
            <p>Enviando...</p>
          </div>
        )}
      </>
    );
  };

  return (
    <div className="home">
      <section className="home image-main" id="home">
        <div className="d-flex align-items-center w-100 h-100">
          <div className="container">
            <Row>
              <Col md={6}>
                <div>
                  <h1>
                    Da ideia ao resultado:
                    <p className="fw-bold" style={{ color: "#fff" }}>
                      a tecnologia é a Ponte!
                    </p>

                  </h1>
                  <div className="mt-4 lh-1">
                    <p className="text-welcome">Bem-Vindos ao mundo da</p>
                    <p className="text-welcome">
                      Pontes Tecnologia & Inovação!
                    </p>
                  </div>
                  <button className="button-welcome pulsered mt-4" onClick={() => openWhatsApp()}>
                    Entre em contato
                  </button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <section className="container" id="about">
        <div className="paragraphs">
          <h4>A Pontes Tecnologia</h4>
          <p className="text">
            Fundada em 2022 com a missão de conectar pessoas, ideias e negócios
            através da inovação. Atuamos no setor de tecnologia com foco em
            entregar soluções criativas, funcionais e sob medida para nossos
            clientes. Desde o início, buscamos ir além do convencional,
            oferecendo um atendimento próximo, escuta ativa e compromisso com
            resultados reais. Acreditamos que tecnologia bem aplicada transforma
            empresas e cria novas possibilidades. Com uma equipe apaixonada pelo
            que faz, seguimos evoluindo, aprendendo e construindo pontes para o
            futuro todos os dias.
          </p>
        </div>
      </section>
      <section className="home image-rectangle" id="team">
        <div className="our">
          <div className="container mt-4">
            <Row>
              <Col md={12} sm={12} className="first-team mt-1">
                <img
                  className="image-team"
                  src={equipe_joao}
                  alt="Imagem João"
                />
                <div className="first-team-group">
                  <span className="team-title">João Paulo</span>
                  <p className="team-text align-items-first mt-1">
                    Formado em Sistemas de Informação e Pós-Graduado em Análise
                    de Dados. Desenvolvedor Full-Stack. Apaixonado por
                    tecnologia e inovação, sempre em busca de soluções criativas
                    e desafiadoras.
                  </p>
                  <p className="team-text align-items-first fw-bold mb-5">
                    “A tecnologia transforma, e é isso que me motiva todos os
                    dias!"
                  </p>
                </div>
              </Col>
              <Col md={12} sm={12} className="second-team">
                <div className="second-team-group">
                  <span className="team-title">Letícia</span>
                  <p className="team-text align-items-second mt-1">
                    Formada em Administração, Gestão de Recursos Humanos e
                    Gestão Financeira. Pós-graduanda em Gestão Estratégica de
                    Marketing e Inteligência Competitiva. Apaixonada por
                    estratégias, planejamento e criação, com foco em resultados.
                  </p>
                  <p className="team-text align-items-second fw-bold mb-5">
                    “Um bom planejamento e um marketing eficaz são o que
                    alavancam sua empresa!”
                  </p>
                </div>
                <img
                  className="image-team"
                  src={equipe_le}
                  alt="Imagem Leticia"
                />
              </Col>
            </Row>
          </div>
        </div>
      </section>
      <div className="home container" id="solutions">
        <div className="paragraphs">
          <h4>Nossas Soluções</h4>
          <p className="text">
            Na Pontes Tecnologia, oferecemos serviços que conectam inovação,
            eficiência e resultados. Cada solução foi pensada para ajudar sua
            empresa a crescer com o suporte da tecnologia certa, no momento
            certo. Conheça um pouco mais sobre o que podemos fazer por você.
          </p>
        </div>
        <Row>
          {service.length > 0 ? (
            isMobile ? (
              <Slider {...settings}>
                {service.map((item, index) => (
                  <Col md={4} sm={12} key={index}>
                    <div className="card mt-4">
                      <div className="card-header">
                        <div className="card-image-services">
                          <img src={images[item.icon]} alt={item.alt} className="img-icon" />
                        </div>
                        <h6 className="ms-3">
                          {item.title}
                          <span className="last-title">{item.last}</span>
                        </h6>
                      </div>
                      <div className="card-body">
                        <span className="card-body-text">{item.text}</span>
                      </div>
                    </div>
                  </Col>
                ))}
              </Slider>
            ) : (
              <>
                {service.map((item, index) => (
                  <Col md={4} sm={12} key={index}>
                    <div className="card mt-4">
                      <div className="card-header">
                        <div className="card-image-services">
                          <img src={images[item.icon]} alt={item.alt} />
                        </div>
                        <h6 className="ms-3">
                          {item.title}
                          <span className="last-title">{item.last}</span>
                        </h6>
                      </div>
                      <div className="card-body">
                        <span className="card-body-text">{item.text}</span>
                      </div>
                    </div>
                  </Col>
                ))}
              </>
            )
          ) : null}
        </Row>
      </div>
      <div className="container mb-5 mt-5 contact-space">
        <Row>
          <Col md={4} sm={12}>
            <div className="contact info">
              <h5>Informações</h5>
              <span className="info-text">
                Prefere falar diretamente com a gente? Confira nossos canais de
                atendimento:
              </span>
              <ContactInfo
                image={"location"}
                alt={"Local"}
                title={"Local"}
                content={["Presidente Prudente - SP"]}
              />
              <ContactInfo
                image={"phoneInfo"}
                alt={"Telefone"}
                title={"Telefone"}
                content={["(18) 99817-4736"]}
              />
              <ContactInfo
                image={"mail"}
                alt={"E-mail"}
                title={"E-mail"}
                content={["contato@pontestecnolog.com.br"]}
              />
            </div>
          </Col>
          <Col md={8} sm={12}>
            <div className={isLoading ? `contact message icon-center` : `contact message`}>
              {renderForm()}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Home;
